import React, { useEffect, useState } from 'react';
import Params from '../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import axios from 'axios';
import { Crypter } from '../../../Functions/Security/Crypter';
import DataType from '../../../Types/DataTablePiclist';
import Datas from '../../../Data/Data.json'
import SelectMultipleOptionPanier from '../../SelectMultipleOptionPanier';


// let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchFinancement  : Params = { CodeAgence: '', Table: "TypeFinancement", Colonne1: "CodeFinancement", Colonne2: "Description", Colagence: '101', Choix: 22 }


function Tab2(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


 
  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
           <Grid item xs={12} md={12}  lg={12} >
                <SelectMultipleOptionPanier   form={props.form}  Size="large"  width={4}  label="Financement"  name="CodeFinancement"  Parametre={searchFinancement} />
             </Grid>
        </Box>
      </div>
    </div>
  )
}

export default Tab2;  
